import { Ajaxinate } from '../../node_modules/ajaxinate';
import { openSMSPopup } from './klavijo-sms-popup';
document.addEventListener("DOMContentLoaded", function () {
  //<Scroll infinity>
  new Ajaxinate({
    container: '#CollectionLoop',
    pagination: '#pagination-custom.pagination-new',
    loadingText: 'Loading...',
    method: 'scroll',
    offset: 1000
  });
  //</Scroll infinity>

  openSMSPopup();
});